<template>
  <div id="homeView">
    <div class="home_container statv_container">
			<section class="home_banner"> <Banner/> </section>
			<section class="home_schedule"> <ScheduleBox/> </section>
			<section class="home_program"> <ProgramBox/> </section>
			<section class="home_channel"> <ChannelBox/> </section>
    </div>
      <aside class="home_notice"> <NoticeBox/></aside>
  </div>
</template>
<script>
import Banner from "./Banner.vue";
import ScheduleBox from "./ScheduleBox.vue";
import ProgramBox from "./ProgramBox.vue";
import ChannelBox from "./ChannelBox.vue";
import NoticeBox from "./NoticeBox.vue";
import Utils from "@/helpers/utils.js";

export default {
	name: "Home",
	components: {
		Banner, ScheduleBox, ProgramBox, ChannelBox, NoticeBox
	},
	data() {
		return {
		viewHeight: 0,
		viewWidth: 0,
		isMobile: false,
		showPopup: false,
		popupData: [],
		}
	},
	created() {
		// this.handleResize();
		this.isMobile = Utils.isMobile()
	},
	mounted() {
		// if(!Utils.isMobile()) window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
		// if(!Utils.isMobile()) window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		handleResize: _.throttle(function(e) {
			this.viewHeight = window.innerHeight
			this.viewWidth = window.innerWidth
			if(this.viewWidth < Utils.getSize().MOBILE) {
				this.isMobile = true
			} else {
						console.log(this.viewWidth)
				this.isMobile = false
					}
			console.log(`[Home View] isMobile : ${this.isMobile}`)
		}, 400),
	},
}
</script>
<style lang="less">
#homeView {
	.home_container {
		background: #FFFFFF 0% 0% no-repeat padding-box;
		cursor: default;
		min-height: 1700px;
		position: relative;
		width: 100%;
		&::before {
			content: "";
			position: absolute;
			background-image: url("~@/assets/image/home/bg_top.png"); 
			background-size: 1920px 100%;
			background-position: center;
			background-repeat: no-repeat;
			top:0;
			left:0;
			width: 100%;
			height: 978px;
			
		}
		&::after {
			content: "";
			position: absolute;
			background-image: url("~@/assets/image/home/bg_bottom.png"); 
			background-size: 482px 100%;
			background-position: right;
			background-repeat: no-repeat;
			bottom:0;
			right:0;
			width: 100%;
			height: 356px;
		}
		.home_banner {
			padding-bottom: 80px;
		}
		.home_schedule {
			width: 100%;
			height: 100%;
			padding-bottom: 60px;
		}
		.home_program {
			padding-bottom: 43px;
      position:relative;
		}
		.home_channel {
			width: 100%;
			height: 100%;
			padding-top: 57px;
			padding-bottom: 160px;
		}
    }
	.home_notice {
		width: 100%;
		padding: 7px 0;
		border-bottom: 1px solid #FFFFFF;
	}
	
}

.m #homeView {
	.home_container {
		&::before {
			background-size: 765px 100%;
			background-image: url("~@/assets/image/home/bg_top_home_m.png"); 
			height: 800px;
		}
		&::after {
			background-size: 282px 100%;
			background-position: right;
			background-image: url("~@/assets/image/home/bg_bottom_m.png"); 
			height: 209px;
		}
	}
	.home_banner {
		padding-bottom: 44px;
	}
	.home_schedule {
		padding-bottom: 50px;
	}
	.home_channel {
		padding-bottom: 170px;
	}
	.home_notice {
		border-bottom: none;
		padding-bottom: 160px;
	}
}

</style>